import {BaseHeaderViewModel} from "./base-header.view-model";
import {NEW_COMPETITOR_CONTAINER} from "../../../containers/competitor-container/competitor-container.consts";
import {BaseHeaderListItemViewModel} from "../modules/mega-header/models/base-header-list-item-view.model";
import {CompetitorCompetitionsViewModel} from "../../../domain/common/competitor/models/competitor-competitions.view-model";
import {CompetitorCompetitionsDomainModel} from "../../../domain/common/competitor/models/competitor-competitions.domain-model";
import {APP, SPORT_TYPES} from "../../../core/app/consts";
import {CompetitorViewModel} from "../../../domain/common/competitor/models/competitor-view-model";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {AppTerms} from "../../../core/app/app-terms";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {CompetitorLinkModel} from "../../../containers/competitor-container/models/competitor-link-model";
import {CompetitorStandingsPageLinkModel} from "../../../containers/competitor-container/pages/standings-page/models/competitor.standings-page.link-model";
import {CompetitorStatsPageLinkModel} from "../../../containers/competitor-container/pages/stats-page/models/competitor.stats-page.link-model";
import {CompetitorSquadPageLinkModel} from "../../../containers/competitor-container/pages/squad-page/models/competitor.squad-page.link-model";
import {CompetitorContainerHashParamsModel} from "../../../containers/competitor-container/models/competitor-container.hash-params-model";

export class CompetitorHeaderViewModel extends BaseHeaderViewModel {
  entity: CompetitorCompetitionsDomainModel;
  minFollowValue: Number

  constructor(terms: AppTerms, navigationManager: NavigationManager, entity: EntityViewModel, isSmallView: Boolean, minFollowValue: Number) {
    super(terms, navigationManager, entity, isSmallView);
    this.entity = entity;
    this.minFollowValue = minFollowValue;
  }

  get entityVM(): CompetitorCompetitionsViewModel {
    return new CompetitorCompetitionsViewModel(this.entity,false, null, this.minFollowValue);
  }

  get entityType() {
    return APP.ANALYTICS.ENTITY_DISPLAY_TYPES[CompetitorViewModel.name]
  }

  get links() {
    const competitorScoresLinkModel = new CompetitorLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);
    competitorScoresLinkModel.settings.resetState = true;

    const competitorStandingsLinkModel: CompetitorStandingsPageLinkModel = new CompetitorStandingsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, NEW_COMPETITOR_CONTAINER.FILTERS.standings, null, this.entity.isFollow);
    const competitorStatsLinkModel: CompetitorStatsPageLinkModel = new CompetitorStatsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);
    const competitorSquadLinkModel: CompetitorSquadPageLinkModel = new CompetitorSquadPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, this.entity.isFollow);

    const bracketsHashParams: CompetitorContainerHashParamsModel = new CompetitorContainerHashParamsModel({brackets: NEW_COMPETITOR_CONTAINER.FILTERS.brackets});
    const competitorBracketsLinkModel = new CompetitorStandingsPageLinkModel(this.entity.id, this.entity.sport.nameForURL, this.entity.nameForURL, NEW_COMPETITOR_CONTAINER.FILTERS.standings, bracketsHashParams, this.entity.isFollow);

    const links: Array<BaseHeaderListItemViewModel> = [];

    const scoresLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
      name: this.terms.WEB_ENTITY_PREVIEW,
      linkModel: competitorScoresLinkModel,
      active: this.isScoresScreenActive,
      index: 0
    });

    links.push(scoresLinkTab);

    if (this.entityVM.hasStandings) {
      const standingsLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
        name: this.terms.STANDINGS,
        linkModel: competitorStandingsLinkModel,
        active: this.isStandingsTabActive,
        index: 1,
        isStandings: true
      });

      links.push(standingsLinkTab);
    }

    if (this.isBracketsTabVisible) {
      const bracketsLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
        name: this.bracketTabName,
        linkModel: competitorBracketsLinkModel,
        active: this.isBracketsTabActive,
        isBrackets: true,
        index: 2,
      });

      links.push(bracketsLinkTab);
    }

    if (this.isStatsTabVisible) {
      const statsLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
        name: this.terms.STATS,
        linkModel: competitorStatsLinkModel,
        active: this.isStatsTabActive,
        isStats: true,
        index: 3,
      });

      links.push(statsLinkTab);
    }

    if (this.isSquadTabVisible) {
      const squadLinkTab: BaseHeaderListItemViewModel = new BaseHeaderListItemViewModel({
        name: this.terms.WEB_SQUAD_TAB,
        linkModel: competitorSquadLinkModel,
        active: this.isSquadTabActive,
        isSquad: true,
        index: 4,
      });

      links.push(squadLinkTab);
    }

    return links;
  }

  get isScoresScreenActive(): Boolean {
    const isScoresScreenActive: Boolean = !this.currentLinkModel.params.filter;

    return isScoresScreenActive;
  }

  get isStandingsTabVisible(): Boolean {
    return this.entity.hasStandings || this.isSmallView
  }

  get isBracketsTabVisible(): Boolean {
    return this.entity.hasBrackets;
  }

  get isStatsTabVisible(): Boolean {
    return this.entity.hasStats;
  }

  get isSquadTabVisible(): Boolean {
    return this.entity.hasSquad;
  }

  get isStandingsTabActive(): Boolean {
    const isStandingsFilter: Boolean = this.currentLinkModel.params.filter === NEW_COMPETITOR_CONTAINER.FILTERS.standings;

    return !this.isBracketsTabActive && isStandingsFilter;
  }

  get isBracketsTabActive(): Boolean {
    return this.currentLinkModel.hashParams.brackets === NEW_COMPETITOR_CONTAINER.FILTERS.brackets;
  }

  get isStatsTabActive(): Boolean {
    const isStatsTabActive: Boolean = this.currentLinkModel.params.filter === NEW_COMPETITOR_CONTAINER.FILTERS.stats;

    return isStatsTabActive
  }

  get isSquadTabActive(): Boolean {
    const isSquadTabActive: Boolean = this.currentLinkModel.params.filter === NEW_COMPETITOR_CONTAINER.FILTERS.squad;

    return isSquadTabActive
  }

  get bracketTabName(): String {
    let bracketTabName = this.terms.WEB_BRACKETS;
    if (this.entity.sport.id === SPORT_TYPES.tennis) {
      bracketTabName = this.terms.WEB_DRAW_INSTEAD_OF_BRACKET;
    }

    return bracketTabName;
  }

  get shouldRenderPopularityRank(): Boolean {
    return this.popularityRank && (this.popularityRank >= this.minFollowValue)
  }
}
